// extracted by mini-css-extract-plugin
export default {"itemTagSelector":"_2rRlS","item":"_1pHM1","null":"_2MHjI app-icon","keyHelp":"_1Mn-3","minimized":"_2vwOb"};